exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n.grecaptcha-badge {\n  width: 70px !important;\n  overflow: hidden !important;\n  transition: all 0.3s ease !important;\n  left: 4px !important; }\n\n.grecaptcha-badge:hover {\n  width: 256px !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":false,"importLoaders":1}!./~/postcss-loader?{"ident":"postcss"}!./~/sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!./src/styles.scss
// module id = 1450
// module chunks = 19